import { Popover, QuestionIcon, RadioGroup, Text } from 'main/ui'
import * as React from 'react'

import {
  Container,
  OnlyMonthlyMessageContainer,
  TooltipContainer,
  TooltipIconContainer,
} from './PaymentFrequency.styles'

export enum PaymentFrequencyOption {
  monthly = 'monthly',
  weekly = 'weekly',
}

const PAYMENT_FREQUENCY_OPTIONS = [
  { label: 'Weekly', value: PaymentFrequencyOption.weekly },
  { label: 'Monthly', value: PaymentFrequencyOption.monthly },
]

interface IProps {
  paymentFrequency: PaymentFrequencyOption
  setPaymentFrequency: (option: PaymentFrequencyOption) => void
  weeklyBillingAccepted: boolean
  hasWeeklyPricesDisplayed: boolean
}

export default function PaymentFrequency(props: IProps) {
  const { weeklyBillingAccepted, hasWeeklyPricesDisplayed, paymentFrequency, setPaymentFrequency } =
    props

  const [tooltipIsOpen, setTooltipIsOpen] = React.useState<boolean>(false)

  return (
    <Container>
      {weeklyBillingAccepted && hasWeeklyPricesDisplayed && (
        <RadioGroup
          onChange={value => {
            const option = PaymentFrequencyOption[value as keyof typeof PaymentFrequencyOption]
            setPaymentFrequency(option)
          }}
          label
          value={paymentFrequency}
          options={PAYMENT_FREQUENCY_OPTIONS}
          inline
        />
      )}

      {!weeklyBillingAccepted && (
        <OnlyMonthlyMessageContainer>
          <Text muted>Only monthly payment available</Text>
          <Popover
            body={<TooltipBody />}
            isOpen={tooltipIsOpen}
            onRequestClose={() => setTooltipIsOpen(false)}
          >
            <TooltipIconContainer onClick={() => setTooltipIsOpen(true)}>
              <QuestionIcon />
            </TooltipIconContainer>
          </Popover>
        </OnlyMonthlyMessageContainer>
      )}
    </Container>
  )
}

function TooltipBody() {
  return (
    <TooltipContainer>
      <Text muted>This provider supports monthly payments only.</Text>
    </TooltipContainer>
  )
}
